module.exports = __webpack_public_path__ + "7231e4f5b1debb36f9f1135dfc4317cf.ico"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/customization/favicon/umacspop.ico
 ** module id = 1343
 ** module chunks = 0
 **/